export default "__VITE_ASSET__BDoKhVtF__"